import React from 'react';
import ReactDOM from 'react-dom';
import './Firebase';
import './assets/css/index.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import App from './components/App';
import reportWebVitals from './reportWebVitals';
import {AuthProvider} from './hooks/useAuth';
import {RecoilRoot} from "recoil"
import 'font-awesome/css/font-awesome.min.css';


ReactDOM.render(
  <React.StrictMode>
    <RecoilRoot>
    <AuthProvider >
      <App />
    </AuthProvider >
    </RecoilRoot>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
